const TEXT_FIELD_HELP_TEXT =
  'Must be between 1 and 64 characters long, use only upper and lowercase letters, 0-9, hyphen (-), and underscore (_).'

export default {
  'failure_flags.page_name': 'Failure Flags',
  'failure_flags.label.plural': 'Failure Flags',
  'failure_flags.label.singular': 'Failure Flag',
  'failure_flags.header.description':
    'Instrument your code with the Failure Flags SDK. If there’s an experiment for your code, the SDK will retrieve the impact configuration and run the handler you provided.',
  'failure_flags.header.sdks.node': 'Failure Flags SDK for NodeJS',
  'failure_flags.header.sdks.python': 'Failure Flags SDK for Python',
  'failure_flags.header.sdks.java': 'Failure Flags SDK for Java',
  'failure_flags.header.sdks.golang': 'Failure Flags SDK for Go',
  'failure_flags.create_experiment_button': 'Experiment',
  'failure_flags.list_page.loading_error': 'Error loading Failure Flags',

  // modals
  'failure_flags.modal.remove_protection.title':
    'Remove Protection for {{name}}?',
  'failure_flags.modal.protect.content_text.application':
    'This service will be excluded from future experiments.',

  // Getting Started
  'failure_flags.getting_started.title': 'Getting Started',
  'failure_flags.incomplete_guide.applications_connected.title':
    'Connect your service',
  'failure_flags.incomplete_guide.applications_connected.description1': 'Our ',
  'failure_flags.incomplete_guide.applications_connected.description2':
    'documentation',
  'failure_flags.incomplete_guide.applications_connected.description3':
    ' will guide you based on your technology stack.',
  'failure_flags.incomplete_guide.applications_detected.title':
    'Annotate your code',
  'failure_flags.incomplete_guide.applications_detected.description':
    'Use one of the SDKs linked above to add Failure Flags to your code. Any Failure Flags you add to your connected services will appear in the list below.',
  'failure_flags.incomplete_guide.experiments_created.title':
    'Create your first experiment',
  'failure_flags.incomplete_guide.experiments_created.description':
    'Experiments are composed of a failure flag and at least one service. Once we detect at least one of each, you will be able to create and run your first experiment.',

  // failure flags list
  'failure_flags.flags_list.title': 'Failure Flags',
  'failure_flags.flags_list.subtitle':
    'Named failure flags show up in this list when they’re requested by at least one of your services.',
  'failure_flags.flags_list.empty_text': 'No Failure Flags detected',
  'failure_flags.flags_list.empty_text2': 'Learn how to annotate your code',
  'failure_flags.flags_list.headers.name': 'Name',
  'failure_flags.flags_list.headers.protected': 'Protected',
  'failure_flags.flags_list.protected.yes': 'Yes',
  'failure_flags.flags_list.protected.no': 'No',
  'failure_flags.flags_list.status.unknown': 'Idle', // TODO not sure yet
  'failure_flags.experiments_list.view_progress': 'View Progress',
  'failure_flags.experiments_list.search': 'Search',

  // applications list
  'failure_flags.applications_list.title': 'Services',
  'failure_flags.applications_list.subtitle':
    'Your services are included in this list when they’re in communication with Gremlin.',
  'failure_flags.applications_list.empty_text': 'No Services detected',
  'failure_flags.applications_list.empty_text2':
    'Learn how to add a sidecar to your container or Lambda Function',
  'failure_flags.applications_list.headers.name': 'Name',
  'failure_flags.applications_list.headers.type': 'Type',
  'failure_flags.applications_list.headers.state': 'State',
  'failure_flags.applications_list.state.active': 'Active',
  'failure_flags.applications_list.state.idle': 'Idle',
  'failure_flags.applications_list.type.aws_lambda': 'AWS Lambda',
  'failure_flags.applications_list.type.kubernetes_pod': 'Kubernetes Pod',
  'failure_flags.applications_list.type.container': 'Container',
  'failure_flags.applications_list.type.ecs_container': 'ECS Task',
  'failure_flags.applications_list.type.azure_function': 'Azure Function',
  'failure_flags.applications_list.type.process': 'Process',
  'failure_flags.applications_list.type.unknown': 'Unknown', // TODO not sure yet
  'failure_flags.applications_list.headers.protected': 'Protected',
  'failure_flags.applications_list.protected.yes': 'Yes',
  'failure_flags.applications_list.protected.no': 'No',

  // application page
  'failure_flags.application_page.title': 'Service',
  'failure_flags.application_page.header': 'Service: {{applicationName}}',
  'failure_flags.application_page.retrieve.error':
    'There was an issue while retrieving this Service',
  'failure_flags.application_page.variants.empty': 'No service variants',
  'failure_flags.application_page.variants.label': 'Service Variants',
  'failure_flags.application_page.variants.header.label': 'Label',
  'failure_flags.application_page.variants.header.value': 'Value',
  'failure_flags.application_page.experiments.empty': 'No experiments',
  'failure_flags.application_page.experiments.label':
    'Experiments Targeting This Service',
  'failure_flags.application_page.experiments.headers.name': 'Name',
  'failure_flags.application_page.protect.success': 'Flag updated successfully',

  // flag page
  'failure_flags.flag_page.title': 'Flag',
  'failure_flags.flag_page.header': 'Flag: {{flagName}}',
  'failure_flags.flag_page.retrieve.error':
    'There was an issue while retrieving this Flag',
  'failure_flags.flag_page.variants.empty': 'No services',
  'failure_flags.flag_page.variants.label': 'Services Using this Flag',
  'failure_flags.flag_page.variants.heading.name': 'Service',
  'failure_flags.flag_page.experiments.empty': 'No experiments',
  'failure_flags.flag_page.experiments.label':
    'Experiments Targeting this Flag',
  'failure_flags.flag_page.experiments.heading.name': 'Experiment',
  'failure_flags.flag_page.protect.success': 'Flag updated successfully',

  // experiments list
  'failure_flags.experiments_list.title': 'Experiments',
  'failure_flags.experiments_list.subtitle':
    'Active and inactive Failure Flag experiments are included in this list. Inactive experiments are hidden after 30 days.',
  'failure_flags.experiments_list.headers.name': 'Name',
  'failure_flags.experiments_list.headers.flag': 'Failure Flag',
  'failure_flags.experiments_list.headers.application': 'Service',
  'failure_flags.experiments_list.headers.last_run': 'Last Run',
  'failure_flags.experiments_list.empty_text': 'No experiments created',
  'failure_flags.experiments_list.status.in_use': 'In Use',
  'failure_flags.experiments_list.status.unknown': 'Unknown',
  'failure_flags.experiments_list.run_experiment.error_message':
    'There was an issue running the experiment {{name}}. Please try again later.',
  'failure_flags.experiments_list.run_experiment.running':
    'Running Experiment {{name}}',

  // create experiment
  'failure_flags.create.create_experiment': 'Create an Experiment',
  'failure_flags.create.new_experiment': 'New Experiment',
  'failure_flags.create.save.success': 'Experiment saved successfully',
  'failure_flags.create.save.error': 'There was an issue saving the experiment',
  'failure_flags.create.save_and_run.success':
    'Experiment saved, now running...',
  'failure_flags.create.save_and_run.error':
    'Experiment saved, but failed to run experiment',
  'failure_flags.create.validation.invalid_effects_json':
    'Invalid JSON. Required',
  'failure_flags.create.navigation_prompt':
    'You have unsaved changes. Are you sure you want to leave?',
  'failure_flags.create.form.fields.experiment_name': 'Experiment Name',
  'failure_flags.create.form.fields.experiment_name.error': `Experiment Name is required. ${TEXT_FIELD_HELP_TEXT}`,
  'failure_flags.create.form.fields.text_field_help_text': TEXT_FIELD_HELP_TEXT, // for now, same for the 3 basic text fields
  'failure_flags.create.form.section.flag_selector': 'Failure Flag Selector',
  'failure_flags.create.form.fields.flag_selector.label': 'Name',
  'failure_flags.create.form.fields.flag_selector.error':
    'Flag Selector is required.',
  'failure_flags.create.form.section.app_selector': 'Service Selector',
  'failure_flags.create.form.fields.app_selector.label': 'Name',
  'failure_flags.create.form.fields.static_targeting.label':
    'Prevent new services from joining at runtime',
  'failure_flags.create.form.fields.app_selector.error':
    'Service Selector is required.',
  'failure_flags.create.form.section.effects': 'Effects',
  'failure_flags.create.form.fields.rate.label': 'Impact Probability',
  'failure_flags.create.form.fields.rate.description':
    '{{percent}}% of applicable failure flags and services will be impacted during this experiment.',
  'failure_flags.create.form.fields.duration.label': 'Experiment Duration',
  'failure_flags.create.form.fields.duration.values.minutes': '{{minutes}} MIN',
  'failure_flags.create.form.fields.duration.values.hours': '{{hours}} HR',
  'failure_flags.create.form.buttons.save': 'Save',
  'failure_flags.create.form.buttons.save_and_run': 'Save & Run',
  'failure_flags.create.form.buttons.cancel': 'Cancel',

  // experiment details
  'failure_flags.experiment_page.title': 'Experiment: {{name}}',
  'failure_flags.experiment_page.title.running': 'Experiment Running: {{name}}',
  'failure_flags.experiment_page.heading.experiment': 'Experiment',
  'failure_flags.experiment_page.heading.running': 'Running',
  'failure_flags.experiment_page.json_attributes': 'Attributes:',
  'failure_flags.experiment_page.flag_selector': 'Failure Flag Selector',
  'failure_flags.experiment_page.application_selector': 'Service Selector',
  'failure_flags.experiment_page.effects.label': 'Effects',
  'failure_flags.experiment_page.effects.duration': 'Experiment Duration',
  'failure_flags.experiment_page.effects.rate': 'Impact Probability',
  'failure_flags.experiment_page.retrieve.error':
    'There was an issue while retrieving this Experiment',
  'failure_flags.experiment_page.start_time': 'Start Time',
  'failure_flags.experiment_page.running_until': 'Running Until',
  // run history
  'failure_flags.experiment_page.run_history.label': 'Experiment Run History',
  'failure_flags.experiment_page.run_history.header.start_time': 'Start Time',
  'failure_flags.experiment_page.run_history.header.stop_time': 'Stop Time',
  'failure_flags.experiment_page.run_history.header.deliveries': 'Deliveries',
  'failure_flags.experiment_page.run_history.header.impacts': 'Impacts',
  'failure_flags.experiment_page.run_history.empty_text': 'No run history',
  // run button
  'failure_flags.experiment_page.run': 'Run',
  'failure_flags.experiment_page.run_experiment.error':
    'There was an issue running the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.run_experiment.success':
    'Running Experiment {{name}}',
  // delete button
  'failure_flags.experiment_page.delete': 'Delete',
  'failure_flags.experiment_page.delete_pending': 'Deleting...',
  'failure_flags.experiment_page.delete_experiment.error':
    'There was an issue deleting the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.delete_experiment.error_running':
    'Cannot delete experiment {{name}} while it is running. Please try again later.',
  'failure_flags.experiment_page.delete_experiment.success':
    'Deleted Experiment {{name}}',
  'failure_flags.experiment_page.delete_experiment.modal_title':
    'Delete Experiment {{name}}?',
  // halt button
  'failure_flags.experiment_page.halt': 'Halt This Experiment',
  'failure_flags.experiment_page.halt_pending': 'Halting This Experiment...',
  'failure_flags.experiment_page.halt_experiment.error':
    'There was an issue halting the experiment {{name}}. Please try again later.',
  'failure_flags.experiment_page.halt_experiment.success':
    'Halted Experiment {{name}}',
  // impacts
  'failure_flags.experiment_page.impacts.label': 'Impacts during this Run'
}
